function GraphIcon({ size = '22', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2501 7.30078C12.6978 7.30078 12.2501 6.85307 12.2501 6.30078C12.2501 5.7485 12.6978 5.30078 13.2501 5.30078H22.2501C22.8024 5.30078 23.2501 5.7485 23.2501 6.30078V15.3008C23.2501 15.8531 22.8024 16.3008 22.2501 16.3008C21.6978 16.3008 21.2501 15.8531 21.2501 15.3008V8.715L13.9572 16.0079C13.5667 16.3984 12.9335 16.3984 12.543 16.0079L8.75012 12.215L2.70723 18.2579C2.3167 18.6484 1.68354 18.6484 1.29302 18.2579C0.902491 17.8674 0.902491 17.2342 1.29302 16.8437L8.04302 10.0937C8.43354 9.70315 9.0667 9.70315 9.45723 10.0937L13.2501 13.8866L19.8359 7.30078H13.2501Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-10.1249"
          y1="11.9258"
          x2="1.52475"
          y2="31.4884"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GraphIcon;
